import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import PropsTypes from "prop-types";
import { UTILS } from "utils";
import { API } from "api";
import { CONSTANTS as C } from "config";
import AddStoreModel from "features/dashboard/components/AddStoreModel";
import { BASE_LANGUAGE } from "config/Constants";
import useUserType from "hooks/useUserType";
import useCatalogue from "hooks/useCatalogue";
import AppPaginatedTable from "components/ui/AppPaginatedTable";
import AppOutlineButton from "components/ui/AppOutlineButton";
import AppSwitch from "components/ui/AppSwitch.jsx";
import { TableManagementPaths } from "features/table-management/routes";
import AppSearchInput from "components/ui/AppSearchInput";
import AppButton from "components/ui/AppButton";


const DashboardBranchesTable = ({as="page", setCurrentMode, setStoreId}) => {
  const userType = useUserType() || UTILS.getCurrentUser()?.userType;// list, create, update
  const [stores, setStores] = useState();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { t } = useTranslation();
  const catelougeType = useCatalogue();
  const router = useHistory();
  const { currentLanguage } = useSelector((state) => state.LanguageSlice);

  const getCurrentUserStores = async () => {
    setLoading(true);
    catelougeType.setLoading(true);
    const userDetail = UTILS.getCurrentUser();
    const result = await API.GET_CRRENT_USER_STORES({
      token: userDetail.token,
      language: currentLanguage ?? "EN",
    });
    if (
      result &&
      result.success == 1 &&
      Array.isArray(result.data) &&
      result.data.length >= 1
    )
      setStores(result.data);
    else {
      if (userType === "MANAGER") {
      } else {
        setOpen(true);
      }
    }

    catelougeType.setLoading(false);
    setLoading(false);
  };

  useEffect(() => {
    getCurrentUserStores();
  }, []);

  const filteredStores = useMemo(() => {
    const rows = Array.isArray(stores) ? stores : [];
    const query = searchTerm.trim().toLowerCase();
    if (!query) return rows;
    return rows.filter((row) => {
      const targetStore = row?.[C.BASE_LANGUAGE] ? row : row?.storeId;
      const name = targetStore?.[C.BASE_LANGUAGE]?.name || "";
      const description = targetStore?.[C.BASE_LANGUAGE]?.description || "";
      return (
        name.toLowerCase().includes(query) ||
        description.toLowerCase().includes(query)
      );
    });
  }, [stores, searchTerm]);

  const publishStore = async (storeId, val) => {
    setLoading(true);
    const userDetail = UTILS.getCurrentUser();
    let s = {
      brandId: userDetail.brandId,
      storeId: storeId,
      isOpened: val,
      language: "EN",
    };
    const result = await API.PUBLISH_UNPUBLISH_STORE({
      token: userDetail.token,
      store: s,
    });
    if (result && result.success === 1) {
      let arr = [...stores];
      let re = arr.map((el) =>
        el._id == storeId ? { ...el, isOpened: val } : el
      );
      setStores(re);
    } else {
    }
    getCurrentUserStores(() => {
      setLoading(false);
    });
  };

  const updateStore = (sId) => {
    if (as === "page") {
      router.push({
        pathname: "/app/dashboard/updatestore",
        state: {
          storeId: sId,
        },
      });
    } else {
      setCurrentMode("update");
      setStoreId(sId);
    }
    
  };

  const renderUpdateStore = (value, rowData, index) => {
    return (
      <AppOutlineButton
        variant="danger"
        className="bg-red-50"
        size="sm"
        onClick={() =>
          updateStore(
            rowData[BASE_LANGUAGE] ? rowData._id : rowData?.storeId?._id
          )
        }
      >
        {t("Update Store Information")}
      </AppOutlineButton>
    );
  };

  const renderAreas = (value, rowData, index) => {
    return (
      <AppOutlineButton
        className="bg-blue-100"
        size="sm"
        onClick={() => {
          localStorage.setItem("storeId", rowData._id);
          router.push({
            pathname: "/app/dashboard/shipping",
            state: {
              sId: rowData[BASE_LANGUAGE] ? rowData._id : rowData?.storeId?._id,
            },
          });
        }}
      >
        {t("Manage Areas")}
      </AppOutlineButton>
    );
  };

  const renderActions = (value, rowData, index) => {
    const resolvedStoreId = rowData[BASE_LANGUAGE]
      ? rowData?._id
      : rowData?.storeId?._id;
    const isOpened = Boolean(value ?? rowData?.storeId?.isOpened);

    return (
      <AppSwitch
        checked={isOpened}
        onChange={(nextChecked) => publishStore(resolvedStoreId, nextChecked)}
      />
    );
  };
  const columns = [
    {
      title: t("Store"),
      dataIndex: "baseLanguage",
      render: (value, rowData, index) => {
        return rowData[C.BASE_LANGUAGE]
          ? rowData[C.BASE_LANGUAGE].name
          : rowData?.storeId[C.BASE_LANGUAGE]?.name;
      },
    },
    {
      title: t("Description"),
      dataIndex: "description",
      render: (value, rowData, index) => {
        return rowData[C.BASE_LANGUAGE]
          ? rowData[C.BASE_LANGUAGE].description
          : rowData?.storeId[C.BASE_LANGUAGE]?.description;
      },
    },
    {
      title: t("Actions"),
      dataIndex: "_id",
      // width: "15%",
      render: renderUpdateStore,
    },
    {
      title: t("Areas"),
      dataIndex: "_id",
      // width: "15%",
      render: renderAreas,
    },
    {
      title: t("Table Management"),
      dataIndex: "_id",
      // width: "15%",
      render: (value, rowData, index) =>
        !rowData?.isDineInEnabled ? (
          <>N/A</>
        ) : (
          <AppOutlineButton
            disabled={!rowData?.isDineInEnabled}
            onClick={() => {
              localStorage.setItem("storeId", rowData._id);
              router.push({
                pathname: TableManagementPaths.tableManagement,
                state: {
                  sId: rowData._id,
                  storeName: rowData?.baseLanguage?.name,
                },
              });
            }}
            className="py-1 px-2 text-13px border border-blue-600 shadow-sm rounded-sm text-blue-600 bg-gray-50 focus:outline-none hover:bg-blue-600 hover:text-white"
          >
            {t("Manage Tables")}
          </AppOutlineButton>
        ),
    },
    {
      title: t("Publish"),
      dataIndex: "isOpened",
      // fixed: "right",
      render: renderActions,
      // width: "12%",
    },
  ];

  return (
    <div className="flex min-h-0 min-w-0 w-full max-w-full flex-col">
      <AddStoreModel
        open={open}
        onClose={() => {
          setOpen(false);
          router.push("/app/dashboard/onboarding");
        }}
      />
      <div className="mb-4 mt-5 flex  gap-3 sm:gap-4 flex-col md:flex-row md:items-center md:justify-between">
        <h2 className="mt-1 text-20px font-semibold w-full">
          {t("Store List")}
        </h2>
        <div className="flex w-full min-w-0 gap-3 flex-col md:flex-row md:items-center md:justify-end sm:gap-4">
          <div className=" w-[320px]">
            <AppSearchInput
              placeholder={t("Search store by name")}
              value={searchTerm}
              onInput={(e) => {
                setSearchTerm(e.target.value);
                setPage(1);
              }}
            />
          </div>
          <div className="w-full sm:w-auto">
            <AppButton
              className="w-full sm:w-auto"
              onClick={() =>{
                if (as === "page") {
                  router.push("/app/dashboard/addstore");
                } else {
                  setCurrentMode("create");
                }
              }}
            >
              {t("Create Store")}
            </AppButton>
          </div>
        </div>
      </div>
      <div className="min-h-0 min-w-0 w-full max-w-full flex-1">
        <AppPaginatedTable
          columns={columns}
          data={filteredStores}
          clientSidePagination
          page={page}
          pageSize={pageSize}
          onPageChange={(nextPage, nextPageSize) => {
            setPage(nextPage);
            setPageSize(nextPageSize || pageSize);
          }}
          rowOptions={[10, 20, 50, 100]}
        />
      </div>
    </div>
  );
};

DashboardBranchesTable.propTypes = {
  data: PropsTypes.array,
};

export default DashboardBranchesTable;
